import React from 'react';
import Searchbar from './components/Searchbar';


const App = () => {

  return (
    <>
      <div className="header">Github Search </div>
      <Searchbar />

    </>
  );
}

export default App;
